import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useCookies } from "react-cookie";
import { resetToken, resetUser } from "../redux/features/authenSlice";
import { persistor } from "../redux/store";

const useLogout = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [, , removeCookie] = useCookies(["token", "userData"]);

  const handleLogout = async () => {
    try {
      dispatch({ type: "RESET" });
      await persistor.purge();
      dispatch(resetToken());
      dispatch(resetUser());
      removeCookie("token", { path: "/" });
      removeCookie("jwt", { path: "/" });
      removeCookie("isVerified", { path: "/" });
      removeCookie("userData", { path: "/" });
      localStorage.clear();
      sessionStorage.clear();
      setTimeout(() => {
        navigate("/signin");
      }, 50);
    } catch (error) {
      console.error("Logout failed:", error);
    }
  };


  return handleLogout;
};

export default useLogout;
